<template>
    <patient-index @handleView="handleView" ></patient-index>
</template>

<script>
  import PatientIndex from './components/register/PatientIndex'
  export default {
    name: 'Register',
    components: { PatientIndex},
    mixins:[],
    data(){
      return{

      }
    },
    computed:{

    },
    mounted(){
      

    },
    methods:{
      handleView(record){
        this.$router.push({path:'/project/patient/registerview/'+record.id})
      }
    }
  }
</script>

<style scoped lang="less">
  .advanced-row{
    width: 100%;
    margin-bottom: 10px;
  }
  .advanced-label{
    text-align: right;
  }
</style>